import { OrganizationCountry } from "../types/countryRegion";
import { UserFormPermissions, UserGeneralPermissions, UserPermissions } from "./user";
export const getOrderedProductPermissions = (organizationCountry) => organizationCountry === OrganizationCountry.GreatBritain
    ? [
        UserPermissions.Donation,
        UserPermissions.Ticketing,
        UserPermissions.Contacts,
        UserPermissions.Bank,
        UserPermissions.TapToPay,
    ]
    : [
        UserPermissions.Donation,
        UserPermissions.Ticketing,
        UserPermissions.Contacts,
        UserPermissions.Receipt,
        UserPermissions.Bank,
        UserPermissions.TapToPay,
    ];
export const orderedActionsPermissions = [UserPermissions.UserManagement];
export const getOrderedPermissions = (organizationCountry) => [
    ...getOrderedProductPermissions(organizationCountry),
    ...orderedActionsPermissions,
];
export const getAllGeneralPermissions = () => Object.values(UserGeneralPermissions);
export const getAllFormPermissions = (organizationCountry) => Object.values(UserFormPermissions).filter((permission) => organizationCountry === OrganizationCountry.GreatBritain ? permission !== UserFormPermissions.Receipt : true);
export const mapUserPermissionsToNewPermissions = (permissions) => {
    return permissions.reduce((acc, permission) => {
        if (permission === UserPermissions.Donation || permission === UserPermissions.Ticketing) {
            acc.formPermissions.push(UserFormPermissions.EditForm);
            acc.formPermissions.push(UserFormPermissions.ManagePayments);
        }
        if (permission === UserPermissions.Receipt) {
            acc.formPermissions.push(UserFormPermissions.Receipt);
        }
        if (permission === UserPermissions.Contacts) {
            acc.generalPermissions.push(UserGeneralPermissions.Contacts);
        }
        if (permission === UserPermissions.Bank) {
            acc.generalPermissions.push(UserGeneralPermissions.Bank);
        }
        if (permission === UserPermissions.TapToPay) {
            acc.generalPermissions.push(UserGeneralPermissions.TapToPay);
        }
        if (permission === UserPermissions.UserManagement) {
            acc.generalPermissions.push(UserGeneralPermissions.UserManagement);
        }
        return acc;
    }, { generalPermissions: [], formPermissions: [] });
};
export const mapNewPermissionsToOldPermissions = ({ generalPermissions, formPermissions, }) => {
    const result = [];
    if (generalPermissions.includes(UserGeneralPermissions.Contacts)) {
        result.push(UserPermissions.Contacts);
    }
    if (generalPermissions.includes(UserGeneralPermissions.Bank)) {
        result.push(UserPermissions.Bank);
    }
    if (generalPermissions.includes(UserGeneralPermissions.TapToPay)) {
        result.push(UserPermissions.TapToPay);
    }
    if (generalPermissions.includes(UserGeneralPermissions.UserManagement)) {
        result.push(UserPermissions.UserManagement);
    }
    if (formPermissions.includes(UserFormPermissions.EditForm)) {
        result.push(UserPermissions.Donation);
        result.push(UserPermissions.Ticketing);
    }
    if (formPermissions.includes(UserFormPermissions.Receipt)) {
        result.push(UserPermissions.Receipt);
    }
    return result;
};
export const hasPermissionOnAtLeastOneForm = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.EditForm));
};
export const hasPermissionOnAtLeastOneFormPayment = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.ManagePayments));
};
export const hasPermissionOnAtLeastOneFormReceipt = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.Receipt));
};
export const hasPermissionOnAllEditForms = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.EditForm)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnAllPayments = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.ManagePayments)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnAllReceipts = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.Receipt)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnUserManagement = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.UserManagement));
};
export const hasPermissionOnContacts = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.Contacts));
};
export const hasPermissionOnBank = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.Bank));
};
export const hasPermissionOnTapToPay = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.TapToPay));
};
